/**
 * Cache Manager for Phantom Trades
 * Handles cache invalidation and force refresh
 */

const CACHE_VERSION_KEY = 'phantomtrades_cache_version';
// Use a fixed version - only change this when you want to force clear all user caches
// DO NOT modify this unless you intentionally want to clear all users' cache
const CURRENT_CACHE_VERSION = 'v3.0.0';

/**
 * Clear application cache while preserving auth tokens
 */
export const clearAllCache = () => {
  try {
    // Preserve auth tokens
    const authToken = localStorage.getItem('phantomtrades_token');
    const authUser = localStorage.getItem('phantomtrades_user');
    const adminToken = localStorage.getItem('adminToken');
    const adminInfo = localStorage.getItem('adminInfo');
    
    // Clear localStorage
    localStorage.clear();
    
    // Restore auth tokens
    if (authToken) localStorage.setItem('phantomtrades_token', authToken);
    if (authUser) localStorage.setItem('phantomtrades_user', authUser);
    if (adminToken) localStorage.setItem('adminToken', adminToken);
    if (adminInfo) localStorage.setItem('adminInfo', adminInfo);
    
    // Clear sessionStorage
    sessionStorage.clear();
    
    // Set new cache version
    localStorage.setItem(CACHE_VERSION_KEY, CURRENT_CACHE_VERSION);
    
    console.log('✅ Cache cleared successfully');
    return true;
  } catch (error) {
    console.error('❌ Error clearing cache:', error);
    return false;
  }
};

/**
 * Check if cache needs to be cleared based on version
 */
export const checkCacheVersion = () => {
  const storedVersion = localStorage.getItem(CACHE_VERSION_KEY);
  
  if (!storedVersion || storedVersion !== CURRENT_CACHE_VERSION) {
    console.log('🔄 Cache version mismatch, clearing cache...');
    clearAllCache();
    return true;
  }
  
  return false;
};

/**
 * Force refresh user data
 */
export const forceRefreshUserData = () => {
  // Remove any cached user data
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.includes('user') || key.includes('balance') || key.includes('wallet'))) {
      keysToRemove.push(key);
    }
  }
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
  console.log(`🔄 Removed ${keysToRemove.length} cached user data items`);
};

/**
 * Initialize cache manager on app load
 */
export const initializeCacheManager = () => {
  checkCacheVersion();
  
  // Add global cache clear function for debugging
  if (typeof window !== 'undefined') {
    window.clearAppCache = clearAllCache;
    window.refreshUserData = forceRefreshUserData;
  }
};
